import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import DefaultLayout from "layouts/Default";
import HeroImage from "assets/img/home/banner/wellness-space.jpg";
import "./index.scss";
import ContentPageProvider from "components/content/ContentPageProvider";
import ContentHTMLItem from "components/content/ContentHTMLItem";

export class LandingTemplatePage extends Component<RouteComponentProps> {
  render() {
    return (
      <DefaultLayout id="landing-template-page">
        <ContentPageProvider url={this.props.location.pathname}>
          <section className="banner">
            <div className="content">
              <div className="tagline">
                <ContentHTMLItem code="tagline">Page tagline</ContentHTMLItem>
              </div>
              <h1>Page title</h1>
              <div className="short-description">Page subtitle.</div>
            </div>
            <img src={HeroImage} className="hero" alt="" />
          </section>
          <section className="content">
            <section>
              <h2>Section title</h2>
              <div className="section-description">Section subtitle</div>
              <p>Section content</p>
            </section>
            <section>
              <h2>Section title</h2>
              <div className="section-description">Section subtitle</div>
              <p>Section content</p>
            </section>
            <section>
              <h2>Section title</h2>
              <div className="section-description">Section subtitle</div>
              <p>Section content</p>
            </section>
          </section>
        </ContentPageProvider>
        <hr />
      </DefaultLayout>
    );
  }
}

export default LandingTemplatePage;
